import { Users, PenTool, Shapes, Mountain, Route, HeartHandshake } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

const CARDS = [
  { icon: Users, tint: "text-arcblue", title: "One Connected Team", copy: "Architecture, design, drafting and construction working together." },
  { icon: PenTool, tint: "text-arcgreen", title: "Designed For You", copy: "Your home is designed around your lifestyle and requirements." },
  { icon: Shapes, tint: "text-arcolive", title: "Custom Rather Than Cookie-Cutter", copy: "Unique plans and designs instead of simply choosing from a standard template." },
  { icon: Mountain, tint: "text-arcorange", title: "Expertise With Irregular Blocks", copy: "Specialised design thinking for unusual and challenging land shapes." },
  { icon: Route, tint: "text-arcpink", title: "End-to-End Management", copy: "A coordinated journey from initial concept through to handover." },
  { icon: HeartHandshake, tint: "text-arcpurple", title: "Personalised Approach", copy: "Work closely with the team to create a home that feels genuinely yours." },
];

export default function WhyUs() {
  return (
    <section className="bg-cream py-24 sm:py-32" data-testid="why-us-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal>
          <p className="eyebrow text-arc mb-6 text-center">Why ArcView</p>
        </Reveal>
        <MaskedLines
          className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl text-center"
          lines={[<>Why Build With <span className="italic text-arc">ArcView?</span></>]}
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.08} className="h-full">
              <div
                className="h-full bg-white border border-line p-8 hover:border-arc/50 hover:shadow-xl hover:shadow-charcoal/5 hover:-translate-y-1.5 transition-all duration-500"
                data-testid={`why-card-${i + 1}`}
              >
                <c.icon size={26} strokeWidth={1.4} className={c.tint} />
                <h3 className="font-serif text-xl sm:text-2xl font-medium text-charcoal mt-6">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{c.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
